import { useEffect } from 'react';
import { useEditorContext } from '../contexts/editor';
import { TinyMCE } from '../types';

export const useEditorEventHandler = (
  events: string[],
  callback: Parameters<Exclude<TinyMCE, undefined>['on']>[1],
) => {
  const { editor } = useEditorContext();

  useEffect(() => {
    if (editor) {
      events.forEach((event) => editor.on(event, callback));

      return () => {
        events.forEach((event) => editor.off(event, callback));
      };
    }
  }, [editor, events]);
};
